/**
 * クライアント側のエラー。code は error イベントのペイロードに載る安定識別子。
 * サーバのエラー封筒（{"error":{"code","message"}}）の code はそのまま引き継ぐ。
 */
export class ViewerError extends Error {
  constructor(
    readonly code: string,
    message: string,
    options?: { cause?: unknown },
  ) {
    super(message, options);
    this.name = 'ViewerError';
  }
}

/** 中断（AbortSignal 由来）かどうか。中断はエラーイベントに載せない。 */
export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}
